import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import transactionLogsService from "./transactionLogsService";

// LIST transaction logs
export const getTransactionLogs = createAsyncThunk(
  "admin/transactionLogs/list",
  async (params, { rejectWithValue }) => {
    try {
      return await transactionLogsService.getTransactionLogs(params);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

// GET transaction log details
export const getTransactionLogDetails = createAsyncThunk(
  "admin/transactionLogs/details",
  async (logId, { rejectWithValue }) => {
    try {
      return await transactionLogsService.getTransactionLogDetails(logId);
    } catch (error) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        error.message ||
        error.toString();
      return rejectWithValue(message);
    }
  }
);

const initialState = {
  transactionLogsList: {
    data: [],
    total: 0,
    pages: 1,
    page: 1,
    per_page: 30
  },
  transactionLogDetails: null,
  isLoading: false,
  isError: false,
  isSuccess: false,
  isDetailsLoading: false,
  isDetailsError: false,
  isDetailsSuccess: false,
  message: "",
};

export const transactionLogsSlice = createSlice({
  name: "adminTransactionLogs",
  initialState,
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.isDetailsError = false;
      state.isDetailsSuccess = false;
      state.isDetailsLoading = false;
      state.message = "";
    },
    clearDetails: (state) => {
      state.transactionLogDetails = null;
      state.isDetailsError = false;
      state.isDetailsSuccess = false;
      state.isDetailsLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET Transaction Logs
      .addCase(getTransactionLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getTransactionLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.transactionLogsList = action.payload;
      })
      .addCase(getTransactionLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      
      // GET Transaction Log Details
      .addCase(getTransactionLogDetails.pending, (state) => {
        state.isDetailsLoading = true;
      })
      .addCase(getTransactionLogDetails.fulfilled, (state, action) => {
        state.isDetailsLoading = false;
        state.isDetailsSuccess = true;
        state.transactionLogDetails = action.payload;
      })
      .addCase(getTransactionLogDetails.rejected, (state, action) => {
        state.isDetailsLoading = false;
        state.isDetailsError = true;
        state.message = action.payload;
      });
  },
});

export const { reset, clearDetails } = transactionLogsSlice.actions;
export default transactionLogsSlice.reducer;